"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('discount', {
            url: '/discount/:id',
            template: require('../views/discount.html'),
            controller: 'DiscountController',
            controllerAs: 'discount',
            params: {
                id: { squash: true, value: null }
            },
            resolve: {
                categories: ['api', function (api) {
                        return api.get('/b2b/discount/categories/list')
                            .then(function (items) {
                            return items;
                        }, function (err) {
                            console.log(err);
                        });
                    }],
                products: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/discount/' + $stateParams.id + '/products/list')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return api.get('/b2b/discount/products/list')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                    }],
                category: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id)
                                .then(function (item) {
                                return item;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return {};
                        }
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/discount/config/routes.js
// module id = 400
// module chunks = 0